require 'angular'

angular.module('workflow.app')

.directive 'entityTypes', () ->
  return {
    scope: { w: "=workflow"}
    template: require('./types.html')
  }
